<template>
  <div id="nav">
    <router-view />
  </div>
</template>

<style lang="scss">
$pvd-enable-helios-styles: true;
@import '@fmr-pr101742/providence-visual-style/styles/visual-style.scss';
@import '@fmr-ap109253/apex-kit/dist/scss/pvd-alert/pvd-alert.scss';
@import '@fmr-ap109253/apex-kit/dist/scss/pvd-button/pvd-button.scss';
@import '@fmr-ap109253/apex-kit/dist/scss/pvd-content-block/pvd-content-block.scss';
@import '@fmr-ap109253/apex-kit/dist/scss/pvd-expand-collapse/pvd-expand-collapse.scss';
@import '@fmr-ap109253/apex-kit/dist/scss/pvd-field-group/pvd-field-group.scss';
@import '@fmr-ap109253/apex-kit/dist/scss/pvd-grid/pvd-grid.scss';
@import '@fmr-ap109253/apex-kit/dist/scss/pvd-icon/pvd-icon.scss';
@import '@fmr-ap109253/apex-kit/dist/scss/pvd-inline-alert/pvd-inline-alert.scss';
@import '@fmr-ap109253/apex-kit/dist/scss/pvd-input/pvd-input.scss';
@import '@fmr-ap109253/apex-kit/dist/scss/pvd-label/pvd-label.scss';
@import '@fmr-ap109253/apex-kit/dist/scss/pvd-link/pvd-link.scss';
@import '@fmr-ap109253/apex-kit/dist/scss/pvd-list-group/pvd-list-group.scss';
@import '@fmr-ap109253/apex-kit/dist/scss/pvd-microcopy/pvd-microcopy.scss';
@import '@fmr-ap109253/apex-kit/dist/scss/pvd-modal/pvd-modal.scss';
@import '@fmr-ap109253/apex-kit/dist/scss/pvd-popover/pvd-popover.scss';
@import '@fmr-ap109253/apex-kit/dist/scss/pvd-progress-indicator/pvd-progress-indicator.scss';
@import '@fmr-ap109253/apex-kit/dist/scss/pvd-spinner/pvd-spinner.scss';
@import '@fmr-ap109253/apex-kit/dist/scss/pvd-tile/pvd-tile.scss';
@import '@fmr-ap109253/apex-kit/dist/scss/pvd-title/pvd-title.scss';
@import '@fmr-ap109253/apex-kit/dist/scss/pvd-tooltip/pvd-tooltip.scss';

#app {
  font-family: $pvd-font-family-sans;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: $pvd-background-color-white;
}

#nav {
  a {
    color: $pvd-color-palette-black;

    :-webkit-any-link {
      color: $pvd-color-palette-black;
    }

    :-moz-any-link {
      color: $pvd-color-palette-black;
    }

    :any-link {
      color: $pvd-color-palette-black;
    }

    &.router-link-exact-active {
      color: #42b983;
    }
  }

  svg.pvd-expand-collapse__icon {
    color: #368727;
  }
}
</style>
